const PERSISTED_KEYS = ['login', 'auth'];

export const loadState = () => {
	try {
		const serializedState = localStorage.getItem('state');
		if (serializedState === null) return undefined;
		const state = JSON.parse(serializedState);
		return PERSISTED_KEYS.reduce((acc, key) => {
			if (state[key] !== undefined) acc[key] = state[key];
			return acc;
		}, {});
	} catch (err) {
		return undefined;
	}
};

export const saveState = (state) => {
	try {
		const serializedState = JSON.stringify(state);
		localStorage.setItem('state', serializedState);
	} catch (err) {
		console.error('Failed to persist state:', err);
	}
};

export { PERSISTED_KEYS };

export const clearState = () => {
	try {
		window.localStorage.clear();
	} catch (err) {
		return err;
	}
};
